// Where a linked task item takes you. Each target page reads its query
// param and opens that record (see StockTable, Inputs, PurchaseOrders, Orders).
import { LinkType } from '../types/tasks';

export function linkUrl(type: LinkType | null, ref: string | null): string | null {
  if (!type || !ref) return null;
  const v = encodeURIComponent(ref);
  switch (type) {
    case 'product':
      return `/stock?product=${v}`;
    case 'input':
      return `/inputs?input=${v}`;
    case 'purchase_order':
      return `/purchase-orders?po=${v}`;
    case 'order':
      return `/orders?order=${v}`;
    default:
      return null;
  }
}

export const LINK_NOUN: Record<LinkType, string> = {
  product: 'Product',
  input: 'Input',
  purchase_order: 'PO',
  order: 'Order',
};

/** A project, opened at one of its nodes. */
export function projectItemUrl(projectId: number, itemId?: number | null): string {
  return itemId ? `/projects/${projectId}?item=${itemId}` : `/projects/${projectId}`;
}

/** Where an item lives: its project's page, or the Lists page. */
export function itemUrl(item: { id: number; list_id: number }, lists: { id: number; kind: string }[]): string {
  const list = lists.find((l) => l.id === item.list_id);
  return list?.kind === 'project' ? projectItemUrl(list.id, item.id) : `/lists?item=${item.id}`;
}
